import React from 'react';

import { Tooltip, useTheme } from '@mui/material';

type IconWithTooltipProps = {
  tooltipTitle: string;
  icon: React.ReactElement;
};

export default function IconWithTooltip({ tooltipTitle, icon }: Readonly<IconWithTooltipProps>) {
  const theme = useTheme();
  return (
    <Tooltip title={tooltipTitle} arrow placement="top" sx={{ color: theme.palette.text.primary }}>
      {React.cloneElement(icon, { fontSize: 'small' } as Record<string, unknown>)}
    </Tooltip>
  );
}
